import { Directive, inject, Input } from '@angular/core';
import { CookieConsentService, COOKIES_CONSENT_KEY } from '@app/core/cookie-consent/cookie-consent.service';
import { ConsentsTranslations } from '@app/shared/models/consents-translations';
import { LegalDocumentLinksService } from '../legal-documents/legal-document-links.service';

@Directive()
export abstract class CookieConsentBaseComponent {
  @Input({ required: true }) public consentsTranslations: ConsentsTranslations;

  protected readonly COOKIES_CONSENT_KEY = COOKIES_CONSENT_KEY;
  protected readonly legalDocumentLinks = inject(LegalDocumentLinksService);
  protected readonly cookieConsentService = inject(CookieConsentService);

  public acceptCookies(): void {
    this.cookieConsentService.accept();
  }

  public rejectCookies(): void {
    this.cookieConsentService.reject();
  }
}
